/**
 * Who pays how much, for every cost card (create/edit summary and order
 * details), so the two screens can never disagree about one order.
 *
 * Mirrors what the backend collects (CarrierProviderService::getOrderPrice):
 * - BY_CUSTOMER: the customer pays the custom fee when one is set, else the
 *   shipping fee; the merchant covers the difference (negative = they gain).
 * - PREPAID: the goods are already paid, but a BY_CUSTOMER shipping fee is
 *   still collected at the door.
 * - The large-order fee is always the merchant's.
 * - PREPAID: Boxy collects nothing for the goods, so the merchant receives 0
 *   (owner, 2026-10-03).
 */
export interface CostAmountsInput {
  goods: number;
  shippingFee: number;
  feeCustomerPayable?: number | string | null;
  byCustomer: boolean;
  prepaid: boolean;
  largeOrderFee?: number;
}

export const costAmounts = ({
  goods,
  shippingFee,
  feeCustomerPayable,
  byCustomer,
  prepaid,
  largeOrderFee = 0,
}: CostAmountsInput) => {
  const custom = Number(feeCustomerPayable) || 0;
  const customerShipping = byCustomer ? (custom > 0 ? custom : shippingFee) : 0;
  const merchantShipping = byCustomer ? (custom > 0 ? shippingFee - custom : 0) : shippingFee;

  return {
    customerShipping,
    merchantShipping,
    customerPays: (prepaid ? 0 : goods) + customerShipping,
    youReceive: prepaid ? 0 : goods - merchantShipping - largeOrderFee,
  };
};
